


// import React, { useState, useEffect } from "react"; // IMPORT useEffect
// import "./../styles/ContactForm.css";
// import contactBanner from "../../../../assets/company/contactUs/women.png";
// import { MdEmail, MdPhone } from "react-icons/md";

// const ContactForm = () => {
//   const [formData, setFormData] = useState({
//     name: "",
//     company_name: "",
//     email: "",
//     phone: "",
//     service: "",
//     message: "",
//   });

//   const [selectedService, setSelectedService] = useState("");
//   const [customService, setCustomService] = useState("");
//   const [showDialog, setShowDialog] = useState(false);
//   const [loading, setLoading] = useState(false);
//   const [success, setSuccess] = useState(false);
//   const [error, setError] = useState("");

//   // CRITICAL FIX: Attach ZoomInfo to the React Form
//   useEffect(() => {
//     const timer = setTimeout(() => {
//       if (window._zi_fc && typeof window._zi_fc.fcRetrigger === 'function') {
//         window._zi_fc.fcRetrigger();
//       }
//     }, 1000); 

//     return () => clearTimeout(timer);
//   }, []);

//   const handleServiceChange = (e) => {
//     const value = e.target.value;
//     setSelectedService(value);
//     setShowDialog(value === "other");
//     if (value !== "other") {
//       setCustomService("");
//       setFormData((prev) => ({ ...prev, service: value }));
//     }
//   };

//   const handleInputChange = (e) => {
//     const { id, value } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [id === "company" ? "company_name" : id]: value,
//     }));
//   };

//   const handleCustomServiceChange = (e) => {
//     const value = e.target.value;
//     setCustomService(value);
//     setFormData((prev) => ({ ...prev, service: value }));
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setSuccess(false);
//     setError("");

//     if (!formData.name || !formData.email || !formData.company_name || !formData.service) {
//       setError("Please fill in all required fields.");
//       setLoading(false);
//       return;
//     }

//     const payload = {
//       name: formData.name.trim(),
//       company_name: formData.company_name.trim(),
//       email: formData.email.trim(),
//       phone: formData.phone.trim(),
//       service: formData.service.trim(),
//       message: formData.message.trim() || "Inquiry from contact form",
//     };

//     try {
//       const response = await fetch(
//         "https://oet4v31oti.execute-api.us-east-2.amazonaws.com/dev/submit",
//         {
//           method: "POST",
//           headers: { "Content-Type": "application/json" },
//           body: JSON.stringify(payload),
//         }
//       );

//       if (response.ok) {
//         setSuccess(true);
//         setError(""); // Ensure error is strictly cleared on success
        
//         // CRITICAL FIX: Isolate ZoomInfo logic to prevent it from crashing the UI
//         try {
//             if (window._zi_fc && typeof window._zi_fc.fcTriggerSubmit === 'function') {
//                 window._zi_fc.fcTriggerSubmit();
//             }
//         } catch (ziError) {
//             console.warn("ZoomInfo tracking encountered an issue:", ziError);
//         }

//         setFormData({
//           name: "",
//           company_name: "",
//           email: "",
//           phone: "",
//           service: "",
//           message: "",
//         });
//         setSelectedService("");
//         setCustomService("");
//         setShowDialog(false);
//       } else {
//         const errorData = await response.json().catch(() => ({}));
//         setError(errorData.message || "Something went wrong. Please try again.");
//       }
//     } catch (err) {
//       setError("Network error. Please check your connection and try again.");
//       setSuccess(false); // Ensure success doesn't stay true if it falls to catch
//       console.error("Submit error:", err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="contact-container">
//       <div className="left-section">
//         <h2 className="contact-heading">Get In Touch</h2>
//         <p className="contact-subheading">
//           Get in Touch to See How We Can Help You Achieve Your IT Goals.
//         </p>
//         <img src={contactBanner} alt="Contact" className="contact-image" />

//         <div className="contact-info-wrapper">
//           <div className="info-column">
//             <div className="info-block">
//               <div className="icon-wrap">
//                 <MdEmail className="info-icon" />
//               </div>
//               <div className="text-wrap">
//                 <div className="info-label">For Support</div>
//                 <a className="info-text" href="mailto:mspsupport@synectiks.com">
//                   mspsupport@synectiks.com
//                 </a>
//               </div>
//             </div>
//           </div>

//           <div className="info-column">
//             <div className="info-block">
//               <div className="icon-wrap">
//                 <MdEmail className="info-icon" />
//               </div>
//               <div className="text-wrap">
//                 <div className="info-label">For Sales</div>
//                 <a className="info-text" href="mailto:info@synectiks.com">
//                   info@synectiks.com
//                 </a>
//               </div>
//             </div>

//             <div className="info-block phone-block">
//               <div className="icon-wrap">
//                 <MdPhone className="info-icon" />
//               </div>
//               <div className="text-wrap">
//                 <div className="info-label">Phone Number</div>
//                 <a className="info-text" href="tel:6096080388">
//                   6096080388 X 1
//                 </a>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       <div className="right-section">
//         <form id="synectiks-contact-form" className="contact-form" onSubmit={handleSubmit}>
//           <label htmlFor="name">
//             Your Name <span>*</span>
//           </label>
//           <input
//             type="text"
//             id="name"
//             name="name"
//             value={formData.name}
//             onChange={handleInputChange}
//             required
//           />

//           <label htmlFor="email">
//             Email <span>*</span>
//           </label>
//           <input
//             type="email"
//             id="email"
//             name="email"
//             value={formData.email}
//             onChange={handleInputChange}
//             required
//           />

//           <label htmlFor="company">
//             Company Name <span>*</span>
//           </label>
//           <input
//             type="text"
//             id="company"
//             name="company_name"
//             value={formData.company_name}
//             onChange={handleInputChange}
//             required
//           />

//           <label htmlFor="phone">Phone (Optional)</label>
//           <input
//             type="tel"
//             id="phone"
//             name="phone"
//             value={formData.phone}
//             onChange={handleInputChange}
//           />

//           <label htmlFor="service">
//             Select Service <span>*</span>
//           </label>
//           <select
//             id="service"
//             name="service"
//             value={selectedService}
//             onChange={handleServiceChange}
//             required
//           >
//             <option value="">--None--</option>
//             <option value="Cloud Migration Services">Cloud Migration Services</option>
//             <option value="Secure Cloud Hosting Services">Secure Cloud Hosting Services</option>
//             <option value="Backup Services">Backup Services</option>
//             <option value="Disaster Recovery Services">Disaster Recovery Services</option>
//             <option value="Virtual Desktops Services">Desktop as a Service </option>
//             <option value="Endpoint Management & Security Services">
//               Endpoint Management & Security Services
//             </option>
//             <option value="Microsoft 365 Services">Microsoft 365 Services</option>
//             <option value="Copilot Services">Copilot Services</option>
//             <option value="Application Development & Modernization">
//               Application Development & Modernization
//             </option>
//             <option value="Cloud Adoption & Migration">Cloud Adoption & Migration</option>
//             <option value="other">Other</option>
//           </select>

//           {showDialog && (
//             <div className="service-dialog">
//               <label htmlFor="customService">
//                 Please specify: <span>*</span>
//               </label>
//               <input
//                 type="text"
//                 id="customService"
//                 name="customService"
//                 value={customService}
//                 onChange={handleCustomServiceChange}
//                 placeholder="Enter your service"
//                 required
//               />
//             </div>
//           )}

//           <label htmlFor="message">Message (Optional)</label>
//           <textarea
//             id="message"
//             name="message"
//             rows="2"
//             value={formData.message}
//             onChange={handleInputChange}
//             placeholder="Tell us more about your needs..."
//           />

//           {error && <p className="error-message">{error}</p>}
//           {success && <p className="success-message">Thank you! We'll get back to you soon.</p>}

//           <button type="submit" className="submit-button" disabled={loading}>
//             {loading ? "Submitting..." : "Submit"}
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ContactForm;














import React, { useState, useEffect } from "react"; // IMPORT useEffect
import "./../styles/ContactForm.css";
import contactBanner from "../../../../assets/company/contactUs/women.png";
import { MdEmail, MdPhone } from "react-icons/md";

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    company_name: "",
    email: "",
    phone: "",
    // service: "",
    message: "",
  });

  const [selectedService, setSelectedService] = useState("");
  const [customService, setCustomService] = useState("");
  const [showDialog, setShowDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState("");

  // CRITICAL FIX: Attach ZoomInfo to the React Form
  useEffect(() => {
    const timer = setTimeout(() => {
      if (window._zi_fc && typeof window._zi_fc.fcRetrigger === 'function') {
        window._zi_fc.fcRetrigger();
      }
    }, 1000); 

    return () => clearTimeout(timer);
  }, []);

  const handleServiceChange = (e) => {
    const value = e.target.value;
    setSelectedService(value);
    setShowDialog(value === "other");
    if (value !== "other") {
      setCustomService("");
      setFormData((prev) => ({ ...prev, service: value }));
    }
  };

  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [id === "company" ? "company_name" : id]: value,
    }));
  };

  const handleCustomServiceChange = (e) => {
    const value = e.target.value;
    setCustomService(value);
    setFormData((prev) => ({ ...prev, service: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setSuccess(false);
    setError("");

    // Commented out the formData.service validation so the form can submit without it
    if (!formData.name || !formData.email || !formData.company_name /* || !formData.service */) {
      setError("Please fill in all required fields.");
      setLoading(false);
      return;
    }

    const payload = {
      name: formData.name.trim(),
      company_name: formData.company_name.trim(),
      email: formData.email.trim(),
      phone: formData.phone.trim(),
      // service: formData.service.trim(),
      message: formData.message.trim() || "Inquiry from contact form",
    };

    try {
      const response = await fetch(
        "https://oet4v31oti.execute-api.us-east-2.amazonaws.com/dev/submit",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      if (response.ok) {
        setSuccess(true);
        setError(""); // Ensure error is strictly cleared on success
        
        // CRITICAL FIX: Isolate ZoomInfo logic to prevent it from crashing the UI
        try {
            if (window._zi_fc && typeof window._zi_fc.fcTriggerSubmit === 'function') {
                window._zi_fc.fcTriggerSubmit();
            }
        } catch (ziError) {
            console.warn("ZoomInfo tracking encountered an issue:", ziError);
        }

        setFormData({
          name: "",
          company_name: "",
          email: "",
          phone: "",
          // service: "",
          message: "",
        });
        setSelectedService("");
        setCustomService("");
        setShowDialog(false);
      } else {
        const errorData = await response.json().catch(() => ({}));
        setError(errorData.message || "Something went wrong. Please try again.");
      }
    } catch (err) {
      setError("Network error. Please check your connection and try again.");
      setSuccess(false); // Ensure success doesn't stay true if it falls to catch
      console.error("Submit error:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-container">
      <div className="left-section">
        <h2 className="contact-heading">Get In Touch</h2>
        <p className="contact-subheading">
          Get in Touch to See How We Can Help You Achieve Your IT Goals.
        </p>
        <img src={contactBanner} alt="Contact" className="contact-image" />

        <div className="contact-info-wrapper">
          <div className="info-column">
            <div className="info-block">
              <div className="icon-wrap">
                <MdEmail className="info-icon" />
              </div>
              <div className="text-wrap">
                <div className="info-label">For Support</div>
                <a className="info-text" href="mailto:mspsupport@synectiks.com">
                  mspsupport@synectiks.com
                </a>
              </div>
            </div>
          </div>

          <div className="info-column">
            <div className="info-block">
              <div className="icon-wrap">
                <MdEmail className="info-icon" />
              </div>
              <div className="text-wrap">
                <div className="info-label">For Sales</div>
                <a className="info-text" href="mailto:info@synectiks.com">
                  info@synectiks.com
                </a>
              </div>
            </div>

            <div className="info-block phone-block">
              <div className="icon-wrap">
                <MdPhone className="info-icon" />
              </div>
              <div className="text-wrap">
                <div className="info-label">Phone Number</div>
                <a className="info-text" href="tel:6096080388">
                  6096080388 X 1
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="right-section">
        <form id="synectiks-contact-form" className="contact-form" onSubmit={handleSubmit}>
          <label htmlFor="name">
            Your Name <span>*</span>
          </label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            required
          />

          <label htmlFor="email">
            Email <span>*</span>
          </label>
          <input
            type="email"
            id="email"
            name="email"
            value={formData.email}
            onChange={handleInputChange}
            required
          />

          <label htmlFor="company">
            Company Name <span>*</span>
          </label>
          <input
            type="text"
            id="company"
            name="company_name"
            value={formData.company_name}
            onChange={handleInputChange}
            required
          />

          <label htmlFor="phone">Phone (Optional)</label>
          <input
            type="tel"
            id="phone"
            name="phone"
            value={formData.phone}
            onChange={handleInputChange}
          />

          {/* COMMENTED OUT SERVICE FIELD
          <label htmlFor="service">
            Select Service <span>*</span>
          </label>
          <select
            id="service"
            name="service"
            value={selectedService}
            onChange={handleServiceChange}
            required
          >
            <option value="">--None--</option>
            <option value="Cloud Migration Services">Cloud Migration Services</option>
            <option value="Secure Cloud Hosting Services">Secure Cloud Hosting Services</option>
            <option value="Backup Services">Backup Services</option>
            <option value="Disaster Recovery Services">Disaster Recovery Services</option>
            <option value="Virtual Desktops Services">Desktop as a Service </option>
            <option value="Endpoint Management & Security Services">
              Endpoint Management & Security Services
            </option>
            <option value="Microsoft 365 Services">Microsoft 365 Services</option>
            <option value="Copilot Services">Copilot Services</option>
            <option value="Application Development & Modernization">
              Application Development & Modernization
            </option>
            <option value="Cloud Adoption & Migration">Cloud Adoption & Migration</option>
            <option value="other">Other</option>
          </select>

          {showDialog && (
            <div className="service-dialog">
              <label htmlFor="customService">
                Please specify: <span>*</span>
              </label>
              <input
                type="text"
                id="customService"
                name="customService"
                value={customService}
                onChange={handleCustomServiceChange}
                placeholder="Enter your service"
                required
              />
            </div>
          )}
          */}

          <label htmlFor="message">Message (Optional)</label>
          <textarea
            id="message"
            name="message"
            rows="2"
            value={formData.message}
            onChange={handleInputChange}
            placeholder="Tell us more about your needs..."
          />

          {error && <p className="error-message">{error}</p>}
          {success && <p className="success-message">Thank you! We'll get back to you soon.</p>}

          <button type="submit" className="submit-button" disabled={loading}>
            {loading ? "Submitting..." : "Submit"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactForm;